export default __webpack_public_path__ + "static/media/timeline_header_left.9706ef95.png";